<template>
  <div id="agentRegisterForm">
    <v-alert
      :value="authStatus.errorAlert"
      type="error"
      class="auth-form__alert-bar"
      transition="scale-transition"
    >
      <div class="auth-form__alert-bar--content">
        {{ authStatus.loginError }}
        <v-btn
          small
          fab
          dark
          flat
          @click="handleResetRegisterForm"
        >
          <v-icon>close</v-icon>
        </v-btn>
      </div>
    </v-alert>
    <v-card class="auth-card">
      <div class="logo-container">
        <img src="/img/homewayz_logo_stacked.svg" alt="Homewayz-Logo">
      </div>
      <v-card-title>
        <v-flex xs12>
          <h2>
            Agent Registration
          </h2>
        </v-flex>
      </v-card-title>
      <div class="mb-3">
        Please use the same email and phone number registered with your MLS account.
      </div>
      <v-form ref="agentRegisterForm" lazy-validation>
        <v-text-field
          v-model="name.value"
          placeholder="Name"
          :rules="nameRules"
        />
        <v-text-field
          v-model="email.value"
          placeholder="E-mail"
          :rules="emailRules"
        />
        <v-text-field
          v-model="phone.value"
          placeholder="Phone number"
          :rules="phoneRules"
          @keypress="isNumber($event)"
        />
        <span class="error" v-html="email.error" />
      </v-form>
      <v-flex xs12 sm6 offset-sm3>
        <loader-button
          :loading="authStatus.loading"
          :disabled="authStatus.loading"
          :btn-text="'Register'"
          :btn-class="'auth-button'"
          @handle-button-click="handleAgentRegisterSubmit"
        />
      </v-flex>
      <router-link :to="{name: 'login'}" class="btn btn-link">
        If you have an account please
        <span>Go to Login</span>
      </router-link>
    </v-card>
    <confirm-modal
      :show="showDialog"
      :text="text"
      :button-text="buttonText"
      @click-button="openLoginPage"
      @close-modal="showDialog = false"
    />
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import LoaderButton from '../uiUtils/LoaderButton.vue'
import ConfirmModal from '../modals/ConfirmModal.vue'
import { emailRules } from '../../utils/formUtils'
import { registerAgentRequest } from '../../services/agentService'

export default {
  components: { LoaderButton, ConfirmModal },

  data: () => ({
    showAlert: false,
    message: '',
    name: {
      value: null,
      apiErrors: null
    },
    phone: {
      value: null,
      apiErrors: null
    },
    email: {
      value: null,
      apiErrors: null,
      error: null
    },
    nameRules: [v => !!v || 'Name is required'],
    phoneRules: [v => !!v || 'Phone is required'],
    emailRules: emailRules,
    showDialog: false,
    text: 'A link with instructions on how to complete the registration has been sent to your email',
    buttonText: 'OK'
  }),

  computed: {
    ...mapState('common', ['authStatus'])
  },

  methods: {
    ...mapMutations('common', {
      deactivateErrorStatus: 'DEACTIVATE_ERROR_STATUS'
    }),
    handleAgentRegisterSubmit() {
      if (this.$refs.agentRegisterForm.validate()) {
        const agentRegisterPayload = {
          email: this.email.value,
          name: this.name.value,
          phone: this.phone.value
        }
        registerAgentRequest(agentRegisterPayload).then((result) => {
          if (result.status === 404) {
            this.email.error = 'This email and phone number are not found in any registered Homewayz MLS.<br/><br/>Please contact <a href="mailto:support@homewayz.io">support@homewayz.io</a> for additional help.'
          } else if (result.status === 409) {
            this.email.error = 'An account already exists for this user; please try to login.<br/><br/>Please contact <a href="mailto:support@homewayz.io">support@homewayz.io</a> for additional help.'
          } else if (result.status !== 200) {
            this.email.error = 'Server error'
          } else {
            this.showDialog = true
          }
        })
      }
    },
    handleResetRegisterForm() {
      this.$refs.agentRegisterForm.reset()
      this.$refs.agentRegisterForm.resetValidation()
      this.deactivateErrorStatus()
    },
    openLoginPage() {
      this.$router.push({ name: 'login' })
    },
    isNumber(evt) {
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
        evt.preventDefault()
      } else {
        return true
      }
    }
  }
}
</script>
<style lang='sass' scoped>
.auth-card
  @media only screen and (max-width: 600px)
    box-shadow: none
    padding: 1rem 2rem

.logo-container
  margin-top: 3rem
  margin-bottom: 5rem

.logo-container img
  width: 320px
  max-width: 320px
  height: auto
  @media only screen and (max-width: 600px)
    width: 90%
.error
  background-color: white !important
  color: red
</style>
